module.exports = __webpack_public_path__ + "static/media/31JFA12.a2617382.jpg";